import React, { useState } from "react";
import { useSignIn, useSignUp } from "@clerk/clerk-react";

interface GoogleAuthButtonProps {
  redirectUrl?: string;
  mode?: "sign-in" | "sign-up";
  className?: string;
}

export default function GoogleAuthButton({
  redirectUrl = "/dubbing",
  mode = "sign-in",
  className = "",
}: GoogleAuthButtonProps) {
  const { signIn, isLoaded: isSignInLoaded } = useSignIn();
  const { signUp, isLoaded: isSignUpLoaded } = useSignUp();
  const [loading, setLoading] = useState(false);

  const handleGoogleAuth = async () => {
    try {
      setLoading(true);
      const authTarget = mode === "sign-up" && signUp ? signUp : signIn;
      if (!authTarget) return;

      await authTarget.authenticateWithRedirect({
        strategy: "oauth_google",
        redirectUrl: "/sso-callback",
        redirectUrlComplete: redirectUrl,
        continueSignUp: true,
        oidcPrompt: "select_account",
        additionalData: {
          prompt: "select_account",
        },
      } as any);
    } catch (err) {
      console.error("Google Auth error:", err);
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleAuth}
      disabled={loading || (!isSignInLoaded && !isSignUpLoaded)}
      aria-label="Continue with Google"
      className={`w-full flex items-center justify-center gap-3 px-4 py-3 rounded-full border border-[#e7e5e4] dark:border-[#292524] bg-white dark:bg-[#141211] text-[#0c0a09] dark:text-white hover:bg-black/[0.03] dark:hover:bg-white/[0.04] text-xs font-medium transition-all shadow-xs active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
        />
      </svg>
      <span>{loading ? "Connecting to Google..." : "Continue with Google"}</span>
    </button>
  );
}
